// src/pages/VerificarSiguiente.js
// Este componente maneja la lógica de los "magic links" para verificar y ligar objetos.

import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import nfcAuthService from '../services/nfcAuthService'; // Asegúrate de que la ruta a tu servicio de autenticación sea correcta

function VerificarSiguiente() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  // Estados para comunicar el proceso al usuario
  const [mensaje, setMensaje] = useState('Verificando tu enlace, por favor espera...');
  const [error, setError] = useState(false);

  useEffect(() => {
    const verificarEnlace = async () => {
      const codigoActivacion = searchParams.get('activacion');

      if (!codigoActivacion) {
        setMensaje('Error: No se encontró el código de activación en el enlace.');
        setError(true);
        return;
      }

      try {
        // 1. Llamamos a la API pública. El backend valida el código.
        const response = await fetch(`/api/verificarActivacion?code=${codigoActivacion}`);
        const data = await response.json();

        if (!response.ok || data.error) {
          throw new Error(data.error || 'No se pudo verificar el enlace. Puede que ya haya sido utilizado.');
        }

        // 2. Si la API devuelve un token, el "magic link" fue exitoso.
        if (data.success && data.token) {
          setMensaje('¡Perfecto! Tu objeto ha sido verificado correctamente. Redirigiendo a tu panel...');
          
          // 3. Usamos el servicio de autenticación para iniciar sesión automáticamente con los nuevos datos.
          // Esto crea la sesión en el navegador del usuario.
          nfcAuthService.loginConDatos(data.token, data.usuario);

          // 4. Esperamos un momento para que el usuario lea el mensaje y luego lo redirigimos a su panel.
          setTimeout(() => {
            navigate('/userpanel');
          }, 2500); // Un pequeño delay para mejorar la experiencia de usuario

        } else {
          // Manejar otros casos, como si el objeto ya estaba activo o el enlace no es válido.
          setMensaje(data.message || 'El enlace ya ha sido utilizado o no es válido.');
          setError(true);
        }

      } catch (err) {
        setMensaje(`Error: ${err.message}`);
        setError(true);
      }
    };

    verificarEnlace();
  }, [searchParams, navigate]); // Se ejecuta solo una vez cuando el componente carga

  // Renderiza un mensaje simple para mantener al usuario informado durante el proceso.
  return (
    <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
      <h3>Verificando tu enlace de Lemmon Tags</h3>
      <div style={{ marginTop: '2rem', fontSize: '1.1rem' }}>
        {!error && <p><em>{mensaje}</em></p>}
        {error && <p style={{ color: '#D32F2F' }}><strong>{mensaje}</strong></p>}
        {/* Aquí podrías añadir un componente de spinner o una animación de carga */}
      </div>
    </div>
  );
}
 
export default VerificarSiguiente;
